// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileHeader1-module__container"};